// Fallbacks greifen nur in Test-/Skriptkontexten, in denen Vite-Defines nicht aufgelöst werden.
export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';
export const APP_BUILD_TIME =
  typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : '1970-01-01T00:00:00.000Z';
